module.exports = __webpack_public_path__ + "img/neutral.44782246.svg";